<template>
  <div class="container-fluid mt-5" v-if="true">
    <!-- Page Title -->
    <div class="row mb-4">
      <div class="col-md-12 px-0">
        <div
          class="d-flex flex-column flex-sm-row justify-content-sm-between mb-3"
        >
          <div>
            <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
              Event Registration
            </div>
            <div>
              <BackRoute />
            </div>
          </div>
          <div class="actions">
            <el-button
              :color="primarycolor"
              class="text-white border-0"
              round
              :loading="loadingsave"
              size="large"
              @click="onContinue"
              :disabled="
                !selectedEvent.id ||
                selectedGroups.length === 0 ||
                !selectedEvent.name
              "
            >
              <span class="text-white">Save</span>
              <span></span>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="p-6">
      <!-- Custom Tabs -->
      <div class="custom-tabs flex-wrap mb-4">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          class="custom-tab flex-wrap"
          :class="{ active: activeTab === tab.id }"
          @click="activeTab = tab.id"
        >
          <span class="fw-500">{{ tab.label }}</span>
        </button>
      </div>

      <!-- Tab Content -->
      <div v-if="activeTab === 'events'" class="tab-section">
        <div class="row">
          <div class="col-12 col-md-6 px-0 d-block d-md-none">
            <h5 class="font-weight-bold s-18 text-head">Upload Event Banner</h5>
            <div
              class="col-md-12 px-0 cursor-pointer"
              @click="altClick"
              v-if="imageUrl"
            >
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <img
                    :src="imageUrl"
                    class="w-100 mx-auto mb-2"
                    style="height: auto"
                  />
                </div>
                <div class="col-md-12">
                  <input
                    type="file"
                    ref="binImage"
                    @change="chooseFile"
                    style="display: none"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!imageUrl"
              class="col-md-12 upload-area"
              @click="altClick"
            >
              <div class="row">
                <div class="col-md-12">
                  <input
                    type="file"
                    ref="binImage"
                    @change="chooseFile"
                    style="display: none"
                  />
                </div>
                <div class="col-md-12 px-0" v-if="!imageUrl">
                  <el-button
                    round
                    color="#EBEDFF"
                    class="upload-area-btn py-4 px-5 w-100"
                    v-if="!imageUrl"
                    >Upload</el-button
                  >
                </div>
              </div>
            </div>
            <div
              v-if="!imageUrl"
              class="col-12 col-md-12 d-flex justify-content-center mt-2"
            >
              <div class="col-md-12 text-head s-18 fw-400">
                No file selected yet.
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 px-0">
            <div class="row my-4">
              <div class="col-md-4 text-md-right">
                <label for="" class="fw-500 s-18 text-head text-dak"
                  >Event <span class="text-danger"> *</span></label
                >
              </div>
              <div class="col-md-7">
                <div class="col-md-12 px-0">
                  <!-- Find event -->
                  <el-dropdown class="w-100" trigger="click">
                    <el-input
                      class="w-100"
                      placeholder="Select from events and activities"
                      v-model="selectedEvent.name"
                      :class="eventError ? 'error-border' : ''"
                    />
                    <template #dropdown>
                      <el-dropdown-menu class="menu-height">
                        <el-dropdown-item
                          v-for="(event, index) in filteredEvents"
                          :key="index"
                          @click="selectEvent(event)"
                          >{{ event.name }}</el-dropdown-item
                        >
                        <el-dropdown-item
                          class="d-flex justify-content-center text-primary font-weight-700"
                          @click="triggerNewEvent"
                          divided
                          ><el-icon>
                            <CirclePlus />
                          </el-icon>
                          Create new event
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-4 text-md-right align-self-center">
                <label for="" class="fw-500 s-18 text-head text-dak"
                  >Event Details</label
                >
              </div>
              <div class="col-md-7">
                <el-input
                  v-model="eventDetails"
                  placeholder="Details"
                  :rows="3"
                  type="textarea"
                />
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-4 text-md-right">
                <label for="" class="fw-500 s-18 text-head text-dak"
                  >Group <span class="text-danger"> *</span></label
                >
              </div>
              <div class="col-md-7">
                <SubgroupSelect
                  v-model="selectedGroups"
                  :items="groups"
                  :loading="grouploading"
                  placeholder="Select group"
                  @filteredGroup="setFilterGroups"
                  @newgroup="setNewGroup"
                  :class="groupError ? 'error-border' : ''"
                />
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-4 text-md-right">
                <label for="" class="fw-500 s-18 text-head text-dak"
                  >Is this a paid event?</label
                >
              </div>
              <div class="col-md-7 d-flex">
                <span class="mr-2"><el-checkbox v-model="markAsPaid" /></span>
                <span class="font-weight-500 mt-1 s-18"
                  >Mark as Paid Event</span
                >
              </div>
            </div>
            <div class="row my-3" v-if="markAsPaid">
              <div class="col-md-4 text-sm-right">Amount</div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-12">
                    <el-input
                      type="text"
                      class="w-100"
                      placeholder=" Amount"
                      v-model="amount"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-6 col-12 mt-3">
                    <label class="fw-500 text-head" for="">
                      Income Account
                    </label>
                    <el-dropdown trigger="click" class="w-100">
                      <span class="el-dropdown-link w-100">
                        <div
                          class="d-flex justify-content-between border-contribution text-secondary w-100"
                        >
                          <span>{{
                            selectedIncomeAccount &&
                            Object.keys(selectedIncomeAccount).length > 0
                              ? selectedIncomeAccount.text
                              : "Select"
                          }}</span>
                          <div>
                            <el-icon class="el-icon--right">
                              <arrow-down />
                            </el-icon>
                          </div>
                        </div>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="(itm, indx) in incomeAccount"
                            :key="indx"
                            @click="setIncomeAccount(itm)"
                            >{{ itm.text }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                  <div class="col-md-6 col-12 mt-3">
                    <label class="fw-500 text-head" for="">
                      Cash Account
                    </label>
                    <el-dropdown trigger="click" class="w-100">
                      <span class="el-dropdown-link w-100">
                        <div
                          class="d-flex justify-content-between border-contribution text-secondary w-100"
                          size="large"
                        >
                          <span>{{
                            selectedCashAccount &&
                            Object.keys(selectedCashAccount).length > 0
                              ? selectedCashAccount.text
                              : "Select"
                          }}</span>
                          <div>
                            <el-icon class="el-icon--right">
                              <arrow-down />
                            </el-icon>
                          </div>
                        </div>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="(itm, indx) in cashBankAccount"
                            :key="indx"
                            @click="setcashBankAccount(itm)"
                            >{{ itm.text }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-7">
                <!-- Payment Gateway Selection -->
                <div class="row">
                  <div class="col-12 mt-2">
                    <div class="form-group">
                      <label class="form-label"
                        >Select payment gateway or channel</label
                      >
                      <el-dropdown class="w-100" trigger="click">
                        <el-input
                          class="w-100"
                          placeholder="Select payment gateway or channel"
                          v-model="selectedGatewayName"
                          readonly
                        >
                          <!-- Append slot for dropdown icon -->
                          <template #suffix>
                            <el-icon>
                              <ArrowDown />
                            </el-icon>
                          </template>
                        </el-input>
                        <template #dropdown>
                          <el-dropdown-menu class="menu-height">
                            <el-dropdown-item
                              v-for="(gateway, index) in gateways"
                              :key="index"
                              @click="selectGateway(gateway)"
                            >
                              {{ gateway.displayName }} -
                              {{
                                gateway.config.bankName
                                  ? gateway.config.bankName
                                  : ""
                              }}
                              -
                              {{
                                gateway.config.bankAccountNumber
                                  ? gateway.config.bankAccountNumber
                                  : ""
                              }}
                              -
                              {{
                                gateway.config.accountName
                                  ? gateway.config.accountName
                                  : ""
                              }}
                            </el-dropdown-item>

                            <el-dropdown-item
                              class="d-flex justify-content-center cursor-pointer text-primary font-weight-700"
                              @click="addNewGateway"
                              divided
                            >
                              <el-icon>
                                <CirclePlus />
                              </el-icon>
                              Add new payment gateway
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                      <div
                        @click="addNewGateway"
                        class="mt-2 d-flex justify-content-end text-dak fw-300 s-13 cursor-pointer"
                      >
                        <u> + Add new payment gateway & bank</u>
                      </div>
                      <!-- Selected List -->
                      <div v-if="selectedGateways.length" class="mt-3">
                        <div
                          v-for="(gateway, index) in selectedGateways"
                          :key="index"
                          class="d-flex justify-content-between align-items-center py-2 border-bottom"
                        >
                          <span class="s-13">
                            {{ gateway.displayName }} -
                            {{
                              gateway.config.bankName
                                ? gateway.config.bankName
                                : ""
                            }}
                            -
                            {{
                              gateway.config.bankAccountNumber
                                ? gateway.config.bankAccountNumber
                                : ""
                            }}
                            -
                            {{
                              gateway.config.accountName
                                ? gateway.config.accountName
                                : ""
                            }}
                          </span>
                          <el-icon
                            class="cursor-pointer text-danger"
                            @click="confirmDelete(gateway)"
                          >
                            <Delete />
                          </el-icon>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 px-0 d-none d-md-block">
            <h5 class="font-weight-bold s-18 text-head">Upload Event Banner</h5>
            <div
              class="col-md-12 px-0 cursor-pointer"
              @click="altClick"
              v-if="imageUrl"
            >
              <div class="row justify-content-center">
                <div class="col-md-12">
                  <img
                    :src="imageUrl"
                    class="w-100 mx-auto mb-2"
                    style="height: auto"
                  />
                </div>
                <div class="col-md-12">
                  <input
                    type="file"
                    ref="binImage"
                    @change="chooseFile"
                    style="display: none"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!imageUrl"
              class="col-md-12 upload-area"
              @click="altClick"
            >
              <div class="row">
                <div class="col-md-12">
                  <input
                    type="file"
                    ref="binImage"
                    @change="chooseFile"
                    style="display: none"
                  />
                </div>
                <div class="col-md-12 px-0" v-if="!imageUrl">
                  <el-button
                    round
                    color="#EBEDFF"
                    class="upload-area-btn py-4 px-5 w-100"
                    v-if="!imageUrl"
                    >Upload</el-button
                  >
                </div>
              </div>
            </div>
            <div
              v-if="!imageUrl"
              class="col-12 col-md-12 d-flex justify-content-center mt-2"
            >
              <div class="col-md-12 text-head s-18 fw-400">
                No file selected yet.
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center mt-4">
          <div class="col-md-6 col-12">
            <el-button
              :color="primarycolor"
              round
              class="text-white py-4 w-100 mt-4"
              @click="goNext('otherInfo')"
            >
              Save and Continue
            </el-button>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'otherInfo'" class="tab-section">
        <div class="row my-3">
          <div class="col-sm-3 text-sm-right align-self-center">
            <label for="locationInput" class="fw-500 s-18 text-dak"
              >Location</label
            >
          </div>
          <div class="col-sm-7">
            <div class="position-relative">
              <el-input
                v-model="searchQuery"
                placeholder="Search Location"
                @input="handleSearchInput"
                @focus="handleInputFocus"
                :trim="true"
                clearable
              />

              <div
                v-if="dropdownVisible"
                class="dropdown-menu w-100 show mt-1 shadow-sm"
                style="
                  position: absolute;
                  top: 100%;
                  left: 0;
                  max-height: 200px;
                  overflow-y: auto;
                  z-index: 1000;
                  background: white;
                "
              >
                <div v-if="isSearching" class="p-2 text-center">
                  <el-icon class="is-loading"><Loading /></el-icon>
                  <span class="ml-2">Searching...</span>
                </div>
                <div v-else>
                  <div
                    v-for="(item, index) in searchResults"
                    :key="index"
                    class="dropdown-item"
                    style="cursor: pointer"
                    @mousedown.prevent
                    @click="selectLocation(item)"
                  >
                    {{ item.display_name }}
                  </div>
                  <div
                    v-if="searchResults.length === 0"
                    class="dropdown-item text-muted"
                  >
                    {{
                      searchQuery.length > 0
                        ? "No results found"
                        : "Start typing to search"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-sm-3 col-md-3 text-sm-right align-self-center">
            <label for="" class="fw-500 s-18 text-dak">Slot</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <el-input
              type="number"
              class="w-100"
              v-model="slot"
              placeholder="slot available"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-3 col-md-3 col-lg-3 text-sm-right">
            <label for="" class="fw-500 s-18 text-dak">Sub Event</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <div class="col-md-12 px-0">
              <!-- <el-select-v2
                            v-model="selectedSubclass"
                            placeholder="Select subclass"
                            class="w-100"
                            :clearable="true"
                            filterable
                        /> -->
              <el-dropdown class="w-100" trigger="click">
                <el-input
                  class="w-100"
                  placeholder="Select from events and activities"
                  v-model="selectedSUbClassEvent.fullEventName"
                />
                <template #dropdown>
                  <el-dropdown-menu class="menu-height">
                    <el-dropdown-item
                      v-for="(event, index) in filterCheckinAttendnceData"
                      :key="index"
                      @click="selectSubClassEvent(event)"
                      >{{ event.fullEventName }} ({{
                        dateFormat(event.eventDate)
                      }})</el-dropdown-item
                    >
                    <el-dropdown-item
                      class="d-flex justify-content-center cursor-pointer text-primary font-weight-700"
                      @click="createNewSubclass"
                      divided
                      ><el-icon>
                        <CirclePlus />
                      </el-icon>
                      Add new subevent
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              <div
                @click="createNewSubclass"
                class="d-flex col-md-12 justify-content-end cursor-pointer"
              >
                <span class="d-flex align-items-center">
                  <el-icon :size="12" class="primary--text mr-1">
                    <Plus />
                  </el-icon>
                  <span class="primary--text s-15 fw-500">
                    Add new subevent</span
                  >
                </span>
              </div>
            </div>
            <div
              v-for="(item, index) in subclasses"
              :key="index"
              class="col-md-12 d-flex p-3 justify-content-between flex-wrap align-items-center border-radius-20 mb-2"
              style="background-color: #7ec0c342"
            >
              <div class="text-dak">{{ item.name }}</div>
              <div class="d-flex align-items-center">
                <div class="primary--text mr-4">
                  {{
                    item.isFree
                      ? "free"
                      : (item.currency ? item.currency : givingForm.currency) +
                        " " +
                        (item.registrationAmount
                          ? item.registrationAmount
                          : "0")
                  }}
                </div>
                <el-icon @click="showConfirmDialog(item.id, index)">
                  <Delete />
                </el-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-3 col-md-3 col-lg-3 text-sm-right">
            <label for="" class="fw-500 s-18 text-dak">Add-ons</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <div class="col-md-12 px-0 my-1">
              <hr class="w-100" />
            </div>
            <div class="col-md-12 px-0">
              <!-- <el-dropdown class="w-100" trigger="click"> -->
              <!-- <el-input
                  class="w-100"
                  placeholder="Add-on"
                  v-model="selectedAddOn.name"
                /> -->
              <!-- <template #dropdown>
                  <el-dropdown-menu class="menu-height">
                    <el-dropdown-item
                      v-for="(item, index) in filterAddOn"
                      :key="index"
                      @click="selectAddOn(item)"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      class="d-flex justify-content-center cursor-pointer text-primary font-weight-700"
                      @click="addNewAddOn"
                      divided
                      ><el-icon>
                        <CirclePlus />
                      </el-icon>
                      Add New Add-on
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template> -->
              <!-- </el-dropdown> -->
              <div
                @click="addNewAddOn"
                class="d-flex col-md-12 justify-content-end"
              >
                <span class="d-flex align-items-center">
                  <el-icon :size="12" class="primary--text mr-1">
                    <Plus />
                  </el-icon>
                  <span class="primary--text cursor-pointer s-15 fw-500">
                    Add New Add-on</span
                  >
                </span>
              </div>
            </div>
            <div
              v-for="(item, index) in addOns"
              :key="index"
              class="col-md-12 d-flex p-3 justify-content-between flex-wrap align-items-center border-radius-20 mb-2"
              style="background-color: #e6f3f5"
            >
              <div class="text-dak">{{ item.name }}</div>
              <div class="d-flex align-items-center">
                <div class="primary--text mr-4">
                  {{ item.isFree ? "free" : " " + item.amount }}
                  <!-- {{ item.isFree ? "free" : item.currency + " " + item.amount }} -->
                </div>
                <el-icon @click="showConfirmModal(item.id, index)">
                  <Delete />
                </el-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-3 col-md-3 text-sm-right align-self-end">
            <label for="" class="fw-500 s-18 text-dak">Cut of time</label>
          </div>
          <div class="col-sm-7 col-md-7">
            <div class="row">
              <div class="col-md-6">
                <div class="fw-500 s-18 text-dak">Registration</div>
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="regCutOffTimer"
                />
              </div>
              <div class="col-md-6">
                <div class="fw-500 s-18 text-dak">Checkin</div>
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="checkinCutOffTime"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-3"></div>
          <div class="col-md-7">
            <el-button
              :color="primarycolor"
              round
              class="text-white w-100 py-4 mt-4"
              @click="goNext('registration')"
            >
              Save and Continue
            </el-button>
          </div>
        </div>
      </div>

      <div v-if="activeTab === 'registration'" class="tab-section">
        <div class="row mt-3">
          <div class="col-sm-3"></div>
          <div class="col-sm-7">
            <div class="d-flex mb-3">
              <button
                v-for="tab in subTabs"
                :key="tab.id"
                class="activeSubTab"
                :class="{ active: activeSubTab === tab.id }"
                @click="activeSubTab = tab.id"
              >
                <span class="fw-500">{{ tab.label }}</span>
              </button>
            </div>
          </div>
        </div>
        <div v-show="activeSubTab === '1'" class="row">
          <div class="col-sm-3 col-md-3"></div>
          <div class="col-sm-7 col-md-7">
            <div class="fw-500 s-18 text-dak">
              Registration SMS default message
            </div>
            <SenderIdVue
              @setselectedsenderid="setSelectedSenderIdRegistration"
            />
            <el-input
              v-model="registrationSMS"
              :rows="4"
              type="textarea"
              placeholder="Registration SMS message body"
              class="mt-3"
            />
          </div>
        </div>
        <div v-if="activeSubTab === '1'" class="row mt-4">
          <div class="col-sm-3 col-md-3"></div>
          <div class="col-sm-7 col-md-7">
            <div class="fw-500 s-18 text-dak">
              Registration Email default message
            </div>
            <el-input
              v-model="registrationEmailSubject"
              placeholder="Email subject"
              type="text"
              class="mt-2"
            />
            <el-input
              v-model="registrationEmail"
              :rows="4"
              type="textarea"
              placeholder="Registration email message body"
              class="mt-3"
            />
          </div>
        </div>

        <div v-show="activeSubTab === '2'" class="row">
          <div class="col-sm-3 col-md-3"></div>
          <div class="col-sm-7 col-md-7">
            <div class="fw-500 s-18 text-dak">Checkin SMS default message</div>
            <SenderIdVue @setselectedsenderid="setSelectedSenderIdCheckin" />
            <el-input
              v-model="checkinSMS"
              :rows="4"
              placeholder="Checkin SMS message body"
              type="textarea"
              class="mt-3"
            />
          </div>
        </div>
        <div v-if="activeSubTab === '2'" class="row mt-4">
          <div class="col-sm-3 col-md-3"></div>
          <div class="col-sm-7 col-md-7">
            <div class="fw-500 s-18 text-dak">
              Checkin Email default message
            </div>
            <el-input
              v-model="checkinEmailSubject"
              type="text "
              placeholder="Email Subject"
              class="mt-2"
            />
            <el-input
              v-model="checkinEmail"
              :rows="4"
              type="textarea"
              placeholder="Checkin email message body"
              class="mt-3"
            />
          </div>
        </div>
        <div class="actions row mt-5">
          <div class="col-sm-3 col-md-3"></div>
          <div class="col-sm-7 col-md-7">
            <el-button
              :color="primarycolor"
              class="text-white w-100 border-0 py-4"
              round
              :loading="loadingsave"
              size="large"
              @click="onContinue"
              :disabled="
                !selectedEvent.id ||
                selectedGroups.length === 0 ||
                !selectedEvent.name
              "
            >
              <span class="text-white">Save</span>
              <span></span>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div
          class="modal"
          tabindex="-1"
          role="dialog"
          id="newActModal"
          :data-toggle="showBtModal"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Create Event</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" data-toggle="modal">
                <div class="row my-4">
                  <div class="col-md-4 text-md-right">
                    <label for="">Event category</label>
                  </div>
                  <div class="col-md-7">
                    <div class="dropdown">
                      <button
                        class="default-bt border border-danger d-flex justify-content-between w-100 text-left pr-1"
                        type="button"
                        style="
                          border-radius: 4px;
                          border: 1px solid #ced4da;
                          color: #6c757d;
                        "
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="ml-3">{{ selectedCategoryName }}</span>
                        <span
                          ><el-icon class="el-icon--right float-right pr-1">
                            <arrow-down /> </el-icon
                        ></span>
                      </button>
                      <div
                        class="dropdown-menu w-100"
                        aria-labelledby="dropdownMenuButton"
                        style="max-height: 350px; overflow-y: auto"
                      >
                        <div class="row w-100 mx-auto">
                          <div class="col-md-12">
                            <el-input
                              type="text"
                              class="w-100"
                              placeholder="Find event"
                              v-model="categorySearchText"
                            />
                          </div>
                        </div>

                        <a
                          class="dropdown-item font-weight-700 small-text py-2 c-pointer"
                          v-for="(category, index) in filteredCategories"
                          :key="index"
                          @click="selectCategory(category)"
                          >{{ category.name }}</a
                        >

                        <!-- Hidden -->
                        <a
                          class="font-weight-bold small-text d-flex justify-content-center py-2 text-decoration-none primary-text c-pointer"
                          style="border-top: 1px solid #002044; color: #136acd"
                          @click="() => (display = true)"
                        >
                          <el-icon class="mr-2">
                            <CirclePlus />
                          </el-icon>
                          Create new event category
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 text-md-right">
                    <label for="">Event date</label>
                  </div>
                  <div class="col-md-7">
                    <el-date-picker
                      v-model="newAcctivityDate"
                      type="date"
                      format="MM/DD/YYYY"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>

                <div class="row py-2 mt-4">
                  <div class="col-md-4 text-md-right">
                    <label for=""></label>
                  </div>
                  <div class="col-md-7 d-flex justify-content-center">
                    <el-button
                      class="default-btn mr-2 secondary-button"
                      data-dismiss="modal"
                      round
                    >
                      Cancel
                    </el-button>
                    <el-button
                      class="ml-2 text-white"
                      :color="primarycolor"
                      round
                      @click="createNewActivity"
                      data-dismiss="modal"
                      :data-toggle="showBtModal"
                      ref="popModal"
                    >
                      Save
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="showPaymentDetail"
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    >
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="row justify-content-center">
            <div class="col-md-8 fw-500 s-30">Set up Payment Gateway</div>
            <div class="col-md-8 col-11 mt-4">
              <label class="fw-500 text-head s-18" for="">Select Bank</label>
              <div class="dropdown w-100">
                <button
                  class="d-flex justify-content-between border-contribution bg-white w-100 pr-1"
                  type="button"
                  style="
                    height: 44px;
                    border-radius: 4px;
                    border: 1px solid #ced4da;
                    color: #6c757d;
                  "
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span>{{
                    !selectedBank
                      ? "Select"
                      : selectedBank.name.length > 27
                      ? `${selectedBank.name.slice(0, 27)}...`
                      : selectedBank.name
                  }}</span>
                  <el-icon class="pr-1">
                    <ArrowDown :size="20" />
                  </el-icon>
                </button>
                <div
                  class="dropdown-menu p-2"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 350px; overflow-y: auto"
                >
                  <el-input
                    type="text"
                    class="w-100"
                    placeholder="Search bank"
                    v-model="bankSearchText"
                  />
                  <a
                    class="dropdown-item elipsis-items cursor-pointer"
                    v-for="item in filteredBanks"
                    :key="item.id"
                  >
                    <div @click="setBank(item)">
                      {{ item ? item.name : "" }}
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <label class="fw-500 text-head s-18" for=""
                >Account Number
              </label>
              <el-input
                type="text"
                class="w-100 input-height"
                placeholder="Enter account number"
                v-model="accountNumber"
                @blur="resolveCustomerDetail"
              />
              <div class="col-md-12 d-flex justify-content-end text-right">
                <span class="text-head font-weight-600">{{ accountName }}</span>
                <div class="align-self-center mt-4" v-if="loading">
                  <div
                    class="spinner-border text-primary"
                    style="width: 2rem; height: 2rem"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <label class="fw-500 text-head s-18" for="">
                Income Account
              </label>
              <el-dropdown trigger="click" class="w-100">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution text-secondary w-100"
                  >
                    <span>{{
                      selectedIncomeAccount &&
                      Object.keys(selectedIncomeAccount).length > 0
                        ? selectedIncomeAccount.text
                        : "Select"
                    }}</span>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(itm, indx) in incomeAccount"
                      :key="indx"
                      @click="setIncomeAccount(itm)"
                      >{{ itm.text }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <label class="fw-500 text-head s-18" for=""> Cash Account </label>
              <el-dropdown trigger="click" class="w-100">
                <span class="el-dropdown-link w-100">
                  <div
                    class="d-flex justify-content-between border-contribution text-secondary w-100"
                    size="large"
                  >
                    <span>{{
                      selectedCashAccount &&
                      Object.keys(selectedCashAccount).length > 0
                        ? selectedCashAccount.text
                        : "Select"
                    }}</span>
                    <div>
                      <el-icon class="el-icon--right">
                        <arrow-down />
                      </el-icon>
                    </div>
                  </div>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="(itm, indx) in cashBankAccount"
                      :key="indx"
                      @click="setcashBankAccount(itm)"
                      >{{ itm.text }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <el-button
                @click="Contiue"
                round
                :color="primarycolor"
                class="text-white py-4 w-100"
                >Save
              </el-button>
            </div>
            <div class="col-md-8 col-11 mt-3">
              <el-button @click="cancel" round class="border-0 w-100"
                >Cancel</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      style="border-radius: 20px"
      v-model="showEventModal"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      top
    >
      <div class="row justify-content-center">
        <div class="col-md-11">
          <div class="col-md-12 text-center s-18 font-weight-600 text-dak mb-4">
            Create New Event
          </div>
          <div class="row my-4">
            <div class="col-md-4 text-md-right">
              <label for="">Event category</label>
            </div>
            <div class="col-md-7">
              <div class="dropdown">
                <button
                  class="default-bt border border-danger d-flex justify-content-between w-100 text-left pr-1"
                  type="button"
                  style="
                    border-radius: 4px;
                    border: 1px solid #ced4da;
                    color: #6c757d;
                  "
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="ml-3">{{ selectedCategoryName }}</span>
                  <span
                    ><el-icon class="el-icon--right float-right pr-1">
                      <arrow-down /> </el-icon
                  ></span>
                </button>
                <div
                  class="dropdown-menu w-100"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 350px; overflow-y: auto"
                >
                  <div class="row w-100 mx-auto">
                    <div class="col-md-12">
                      <el-input
                        type="text"
                        class="w-100"
                        placeholder="Find event"
                        v-model="categorySearchText"
                      />
                    </div>
                  </div>

                  <a
                    class="dropdown-item font-weight-700 small-text py-2 c-pointer"
                    v-for="(category, index) in filteredCategories"
                    :key="index"
                    @click="selectCategory(category)"
                    >{{ category.name }}</a
                  >

                  <!-- Hidden -->
                  <a
                    class="font-weight-bold small-text d-flex justify-content-center py-2 text-decoration-none primary-text c-pointer"
                    style="border-top: 1px solid #002044; color: #136acd"
                    @click="createNewCat"
                  >
                    <el-icon class="mr-2">
                      <CirclePlus />
                    </el-icon>
                    Create new event category
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 text-md-right">
              <label for="">Event date</label>
            </div>
            <div class="col-md-7">
              <el-date-picker
                v-model="newAcctivityDate"
                type="date"
                format="MM/DD/YYYY"
                size="large"
                class="w-100"
              />
            </div>
          </div>

          <div class="row py-2 mt-4">
            <div class="col-md-4 text-md-right">
              <label for=""></label>
            </div>
            <div class="col-md-7 d-flex justify-content-center">
              <el-button size="large" class="mr-2 secondary-button" round>
                Cancel
              </el-button>
              <el-button
                class="ml-2 text-white"
                :color="primarycolor"
                round
                size="large"
                @click="createNewActivity"
              >
                Save
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showEventCatModal"
      title="Create Event Category"
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      align-center
    >
      <div class="row">
        <div class="col-md-12">
          <CreateEventModal
            @new-created="newCategoryCreated"
            @closeeventmodal="closeModal"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showSubClassModal"
      title=""
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      align-center
    >
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-12 text-center text-dak fw-500 s-20">
              Add New Subclass
            </div>
            <div class="col-md-12 mt-4">
              <label for="" class="fw-500 s-18 text-head text-dak"
                >Select Event</label
              >
              <div class="col-md-12 px-0">
                <!-- Find event -->
                <el-dropdown class="w-100" trigger="click">
                  <el-input
                    class="w-100"
                    placeholder="Select from events and activities"
                    v-model="selectedEvent.name"
                  />
                  <template #dropdown>
                    <el-dropdown-menu class="menu-height">
                      <el-dropdown-item
                        v-for="(event, index) in filteredEvents"
                        :key="index"
                        @click="selectEvent(event)"
                        >{{ event.name }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        class="d-flex justify-content-center text-primary font-weight-700"
                        @click="triggerNewEvent"
                        divided
                        ><el-icon>
                          <CirclePlus />
                        </el-icon>
                        Create new event
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </div>
            <div class="col-md-12 mt-3">
              <label for="" class="fw-500 s-18 text-head text-dak"
                >Event Details</label
              >
              <el-input
                v-model="subClassEventDetails"
                placeholder="Details"
                :rows="2"
                type="textarea"
              />
            </div>
            <div class="col-md-12 mt-3">
              <label for="" class="fw-500 s-18 text-head text-dak"
                >Select Group</label
              >
              <SubgroupSelect
                v-model="selectedSubClassGroups"
                :items="groups"
                :loading="grouploading"
                placeholder="Select group"
                @filteredGroup="setFilterSubClassGroups"
                @newgroup="setNewGroup"
              />
            </div>
            <div class="col-md-12 mt-3" v-if="!markAsFree">
              <label class="s-15 text-dak">Amount</label>
              <div class="amount-input-group">
                <el-select
                  v-model="givingForm.currency"
                  class="currency-select mr-2"
                  @change="setSelectedCurrency"
                >
                  <el-option
                    v-for="currency in supportedCurrencies"
                    :key="currency.value"
                    :label="currency.value"
                    :value="currency.value"
                  />
                </el-select>
                <el-input
                  v-model="givingForm.registrationAmount"
                  type="number"
                  placeholder="0.00"
                  class="amount-input"
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
            <div class="col-md-12">
              <el-checkbox size="large" v-model="markAsFree" /> Mark as free
            </div>
            <div class="col-md-12 mt-5 mb-3">
              <div
                class="d-flex flex-column align-items-center justify-content-center"
              >
                <el-button
                  class="text-white w-100"
                  :color="primarycolor"
                  round
                  size="large"
                  @click="addNewSubclass"
                  >Save Subclass</el-button
                >
                <el-button
                  class="text-dak w-100"
                  link
                  size="large"
                  @click="closeSubClassModal"
                >
                  <span class="fw-500 mt-3">Cancel</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showAddOnModal"
      title=""
      class="border-radius-20"
      :width="mdAndUp || lgAndUp || xlAndUp ? `45%` : `90%`"
      align-center
    >
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-12 text-center text-dak fw-500 s-20">
              Add Add-on
            </div>
            <div class="col-md-12 mt-4">
              <label class="s-15 text-dak">Add-on name</label>
              <el-input
                type="text"
                v-model="addOnName"
                placeholder="Enter Add-on name"
                style="background-color: #e9feff !important"
                class="w-100"
              />
            </div>
            <div class="col-md-12 mt-3" v-if="!markAddOnAsFree">
              <label class="s-15 text-dak">Amount</label>
              <div class="amount-input-group">
                <!-- <el-select
                  v-model="givingForm.currency"
                  class="currency-select mr-2"
                  @change="setSelectedCurrency"
                >
                  <el-option
                    v-for="currency in currencyList"
                    :key="currency.id"
                    :label="currency.shortCode"
                    :value="currency.id"
                  />
                </el-select> -->
                <el-input
                  v-model="givingForm.amount"
                  type="number"
                  placeholder="0.00"
                  class="amount-input"
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
            <div class="col-md-12">
              <el-checkbox size="large" v-model="markAddOnAsFree" /> Mark as
              free
            </div>
            <div class="col-md-12 mt-5 mb-3">
              <div
                class="d-flex flex-column align-items-center justify-content-center"
              >
                <el-button
                  class="text-white w-100"
                  :color="primarycolor"
                  round
                  size="large"
                  @click="saveNewAddOn"
                  >Save</el-button
                >
                <el-button
                  class="text-dak w-100"
                  link
                  size="large"
                  @click="closeSubClassModal"
                >
                  <span class="fw-500 mt-3">Cancel</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-model="showPaymentDialog"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `40%` : `90%`"
      :show-close="true"
      class="border-radius-20"
      @close="closePaymentModal"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center text-dak font-weight-600 s-20">
            ChurchPlus Payment Details
          </div>
          <div class="col-md-12 mt-2 px-0"><hr class="w-100" /></div>
        </div>

        <!-- 🔹 Payment Form Selector -->
        <div class="row mt-3 px-3">
          <div class="col-12 mb-3">
            <label class="form-label">Select Payment Gateway Category </label>
            <el-select
              v-model="selectedPaymentForm"
              placeholder="Select payment option"
              class="w-100"
              @change="getFinancialGateway"
            >
              <el-option
                v-for="form in paymentForms"
                :key="form.id"
                :label="form.label"
                :value="form"
              />
            </el-select>
            <span class="font-italic s-12 fw-500">{{
              selectedPaymentForm?.description
            }}</span>
          </div>
        </div>
        <div class="row" v-if="loadingIntegrationType">
          <div class="col-md-12 d-flex justify-content-center">
            <el-icon class="is-loading">
              <Loading />
            </el-icon>
          </div>
        </div>

        <!-- Form Fields -->
        <div class="row px-3" v-if="selectedPaymentForm?.value === 'bank'">
          <div class="col-md-12">
            <el-form label-position="top">
              <!-- Choose Bank -->
              <div class="row mt-2">
                <div class="col-12">
                  <label class="form-label">Select Gateway Payment </label>
                  <el-select
                    v-model="selectGatewayPaymentID"
                    placeholder="Select payment gateway"
                    class="w-100"
                    @change="setSelectedGatewayPayment"
                  >
                    <el-option
                      v-for="item in gateWayPayments"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
              </div>
              <!-- Choose Bank -->
              <div class="row mt-3">
                <div class="col-12 mb-3">
                  <label class="form-label">Choose Bank</label>
                  <el-select
                    v-model="selectedBankID"
                    filterable
                    placeholder="Choose Bank"
                    class="w-100"
                    @change="setSelectedBank"
                  >
                    <el-option
                      v-for="(bank, index) in filteredBanks"
                      :key="index"
                      :label="bank.name"
                      :value="bank.id"
                    />
                  </el-select>
                </div>
              </div>

              <!-- Account Number -->
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">Account Number</label>
                  <el-input
                    type="text"
                    v-model="accountNumber"
                    placeholder="Account number"
                    class="w-100"
                    @blur="resolveCustomerDetail"
                  />
                  <span v-if="loading">
                    <el-icon :size="20" class="is-loading">
                      <Loading /> </el-icon
                  ></span>
                </div>
              </div>

              <!-- Account Name -->
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">Account Name</label>
                  <el-input
                    type="text"
                    v-model="accountName"
                    placeholder="Account name"
                    class="w-100 account-name-input"
                    disabled
                  />
                  <small class="helper-text"
                    >This will automatically come up</small
                  >
                </div>
              </div>
            </el-form>

            <div class="row">
              <div class="col-12">
                <div class="dialog-footer">
                  <el-button
                    round
                    :color="primarycolor"
                    class="w-100 py-4 text-white"
                    @click="saveGateway"
                  >
                    Save
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Connect a Payment Gateway -->
        <div class="row px-3" v-if="selectedPaymentForm?.value === 'connect'">
          <div class="col-md-12">
            <div class="row mt-2">
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Select Gateway Payment </label>
                  <el-select
                    v-model="selectGatewayPaymentID"
                    placeholder="Select payment gateway"
                    class="w-100"
                    @change="setSelectedGatewayPayment"
                  >
                    <el-option
                      v-for="item in gateWayPayments"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">External Account Ref</label>
                <el-input
                  type="text"
                  v-model="connectForm.externalAccountRef"
                  placeholder="Enter external account reference"
                  class="w-100"
                />
              </div>
            </div>

            <!-- Access Token -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Access Token</label>
                <el-input
                  type="text"
                  v-model="connectForm.accessTokenEncrypted"
                  placeholder="Enter encrypted access token"
                  class="w-100"
                />
              </div>
            </div>

            <!-- Refresh Token -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Refresh Token</label>
                <el-input
                  type="text"
                  v-model="connectForm.refreshTokenEncrypted"
                  placeholder="Enter encrypted refresh token"
                  class="w-100"
                />
              </div>
            </div>

            <!-- Connected At -->
            <div class="row">
              <div class="col-12 mb-3">
                <label class="form-label">Connected At</label>
                <el-date-picker
                  v-model="connectForm.connectedAt"
                  type="datetime"
                  placeholder="Select connected date"
                  class="w-100"
                  size="large"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-12 mt-3">
                <div class="dialog-footer">
                  <el-button
                    round
                    :color="primarycolor"
                    class="text-white py-4 w-100"
                    @click="saveGateway"
                  >
                    Save
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Business Public & Private Key -->
        <div
          class="row px-3"
          v-if="selectedPaymentForm?.value === 'pub-priv-key'"
        >
          <div class="col-md-12">
            <el-form label-position="top">
              <!-- Choose Bank -->
              <div class="row mt-2">
                <div class="col-12">
                  <div class="form-group">
                    <label class="form-label">Select Gateway Payment </label>
                    <el-select
                      v-model="selectGatewayPaymentID"
                      placeholder="Select payment gateway"
                      class="w-100"
                      @change="setSelectedGatewayPayment"
                    >
                      <el-option
                        v-for="item in gateWayPayments"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      />
                    </el-select>
                  </div>
                </div>
              </div>

              <!-- Public key -->
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">Public Key</label>
                  <el-input
                    type="text"
                    v-model="keysForm.publicKeyEncrypted"
                    placeholder="000000"
                    class="w-100"
                  />
                </div>
              </div>

              <!-- Privite key -->
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">Secret Key</label>
                  <el-input
                    type="text"
                    v-model="keysForm.secretKeyEncrypted"
                    placeholder="000000"
                    class="w-100"
                  />
                </div>
              </div>
              <!-- Webhook Key -->
              <div class="row">
                <div class="col-12 mb-3">
                  <label class="form-label">Webhook Key</label>
                  <el-input
                    v-model="keysForm.webhookKeyEncrypted"
                    type="text"
                    placeholder="000000"
                    style="background-color: #e9feff"
                    class="w-100"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-dak s-15 text-center">
                  Kindly update your webhook url with
                </div>
                <div
                  class="col-12 font-italic text-center font-weight-bold s-15 text-dak"
                >
                  http://churchplus.co/webhooks/name
                </div>
              </div>
            </el-form>
            <div class="row">
              <div class="col-12 mt-3">
                <div class="dialog-footer">
                  <el-button
                    round
                    :color="primarycolor"
                    class="w-100 py-4 text-white"
                    @click="saveGateway"
                  >
                    Save
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  nextTick,
  reactive,
  watch,
  ref,
  inject,
} from "vue";
import { useRoute } from "vue-router";
import router from "@/router/index";
import SubgroupSelect from "../../groups/component/SubgroupSelect.vue";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import groupService from "../../../services/groups/groupsservice";
import eventsService from "../../../services/events/eventsservice";
import CreateEventModal from "../../../components/attendance/AttendanceEventModal";
import { useStore } from "vuex";
import axios from "@/gateway/backendapi";
import finish from "../../../services/progressbar/progress";
import axio from "axios";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import collector from "../../../services/groupArray/mapTree";
import flatten from "../../../services/groupArray/flatTree";
import { ElNotification, ElMessageBox } from "element-plus";
import SenderIdVue from "../../../components/senderId/SenderId.vue";
import supportedCurrencies from "@/services/user/flutterwaveSupportedCurrency";
import dateFormatter from "../../../services/dates/dateformatter";
// import PaymentGatewayManager from "../../components/payment/PaymentGatewayManager.vue";

const primarycolor = inject("primarycolor");
const selectedGatewayName = ref("");
const store = useStore();
const route = useRoute();
const markAsPaid = ref(false);
const groups = ref([]);
const display = ref(false);
const newActModal = ref(false);
const showBtModal = ref("");
const popModal = ref(null);
const openModalBtn = ref(null);
const addPaidClass = ref(false);
const addFreeClass = ref(true);
const showEventModal = ref(false);
const templateDisplay = ref(false);
const nigerianBanks = ref([]);
const markAsFree = ref(true);
const markAddOnAsFree = ref(true);
const defaultCurrency = ref({});
const accountNumber = ref("");
const accountName = ref("");
const addOnName = ref("");
// const accNameRef = ref("");
const loading = ref(false);
const loadingsave = ref(false);
const showSubClassModal = ref(false);
const showAddOnModal = ref(false);
const eventDetails = ref("");
const subClassEventDetails = ref("");
const cashBankAccount = ref([]);
const incomeAccount = ref([]);
const selectedIncomeAccount = ref({});
const selectedCashAccount = ref(null);
const registrationSMS = ref("");
const registrationEmail = ref("");
// const selectLocation = ref("");
const checkinSMS = ref("");
const checkinEmail = ref("");
const amount = ref("");
const binImage = ref("");
const image = ref("");
const imageUrl = ref("");
const slot = ref("");
const hideDiv = ref(true);
const searchGroupRef = ref(true);
const showPaymentDetail = ref(false);
const searchGroupText = ref("");
const grouploading = ref(false);
const checkinCutOffTime = ref("");
const regCutOffTimer = ref("");
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const checkinSMSSubject = ref("");
const registrationSMSSubject = ref("");
const registrationEmailSubject = ref("");
const checkinEmailSubject = ref("");
const loadingIntegrationType = ref(false);
const searchQuery = ref("");
const searchResults = ref([]);
const selectedLocation = ref(null);
const dropdownVisible = ref(false);
const isSearching = ref(false);
const debounceTimer = ref(null);
const showEventCatModal = ref(false);
const currencyList = ref([]);
const checkinAttendnceData = ref([]);
const subclasses = ref([]); // dynamic Attendances
const addOns = ref([]); // dynamic EventAddOns
const selectedGroups = ref([]);
const selectedSubClassGroups = ref([]);
const currencyDetail = ref({});

const givingForm = reactive({
  registrationAmount: "",
  amount: "",
  currency: "NGN",
});
const setSelectedCurrency = () => {
  defaultCurrency.value = currencyList.value.find(
    (i) => i.shortCode === givingForm.currency
  );
  console.log("Selected currency:", defaultCurrency.value);
};
const getCurrentSignedInUser = async () => {
  try {
    const { data } = await axios.get(`/api/Membership/GetCurrentSignedInUser`);
    console.log("User sign in:", data);
    currencyDetail.value = data;
  } catch (err) {
    console.log(err);
  }
};
getCurrentSignedInUser();

const dateFormat = (date) => {
  return dateFormatter.monthDayYear(date);
};
// --- Connect form fields ---
const connectForm = reactive({
  externalAccountRef: "",
  accessTokenEncrypted: "",
  refreshTokenEncrypted: "",
  connectedAt: new Date().toISOString(),
});

// --- Public/Private Keys form fields ---
const keysForm = reactive({
  publicKeyEncrypted: "",
  secretKeyEncrypted: "",
  webhookSecretEncrypted: "",
});
const paymentForms = ref([
  {
    id: 0,
    label: "ChurchPlus Gateway – Quick Start (Recommended)",
    value: "bank",
    description:
      "No setup required, fastest to start. ChurchPlus handles settlement, payouts, and compliance.",
  },
  {
    id: 1,
    label: "Own Gateway – Easy Setup (Linked Account / Connect)",
    value: "connect",
    description:
      "The church connects their Stripe, Paystack, or other supported platforms via OAuth or dashboard link.",
  },
  {
    id: 2,
    label: "Custom Gateway – Use API Keys",
    value: "pub-priv-key",
    description:
      "The most advanced option where the church pastes API keys. Best for tech-savvy teams or larger churches.",
  },
]);

const activeTab = ref("events"); // default tab
const activeSubTab = ref("1"); // default tab
const selectedGateways = ref([]);
const gateways = ref([]);
const showPaymentDialog = ref(false);
const selectedPaymentForm = ref(null); // "bank" | "connect" | "pub-priv-key"
const selectGatewayPaymentID = ref(null);
const selectedBankID = ref(null);
const selectedPaymentGateway = ref({});
const gateWayPayments = ref([]);
const selectedBank = ref({});
const eventError = ref(false);
const groupError = ref(false);

// Move between tabs
const goNext = (nextTab) => {
  eventError.value = false;
  groupError.value = false;
  // Validation before proceeding
  if (markAsPaid.value && !amount.value) {
    ElNotification({
      title: "Missing Amount",
      message: "Please enter an amount.",
      type: "warning",
      duration: 3000,
    });
    return; // stop navigation
  }

  if (markAsPaid.value && !selectedIncomeAccount.value?.id) {
    ElNotification({
      title: "Missing Account",
      message: "Please select an income account.",
      type: "warning",
      duration: 3000,
    });
    return;
  }

  if (markAsPaid.value && !selectedCashAccount.value?.id) {
    ElNotification({
      title: "Missing Cash Account",
      message: "Please select a cash account.",
      type: "warning",
      duration: 3000,
    });
    return;
  }
  if (markAsPaid.value && selectedGateways.value.length === 0) {
    ElNotification({
      title: "No Payment Gateway Selected",
      message: "Please select at least one payment gateway to proceed.",
      type: "warning",
      duration: 3000,
    });
    return;
  }
  // 🚨 NEW VALIDATION: EVENT MUST BE SELECTED
  if (!selectedEvent.value?.id) {
    eventError.value = true; // 🔴 highlight event input
    ElNotification({
      title: "Event Required",
      message: "Please select an event before continuing.",
      type: "warning",
      duration: 3000,
    });
    return;
  }

  // 🚨 NEW VALIDATION: AT LEAST ONE GROUP MUST BE SELECTED
  if (!selectedGroups.value || selectedGroups.value.length === 0) {
    groupError.value = true; // 🔴 highlight group input
    ElNotification({
      title: "Group Required",
      message: "Please select at least one group before proceeding.",
      type: "warning",
      duration: 3000,
    });
    return;
  }

  // ✅ All good — go to next tab
  activeTab.value = nextTab;
};

const tabs = [
  { id: "events", label: "Primary Details" },
  { id: "otherInfo", label: "Other Info" },
  { id: "registration", label: "Email & SMS" },
];
const subTabs = [
  { id: "1", label: "Registration" },
  { id: "2", label: "Checkin" },
];
const addNewGateway = () => {
  showPaymentDialog.value = true;
};
const closePaymentModal = () => {
  showPaymentDialog.value = false;
};
const setSelectedBank = () => {
  selectedBank.value = nigerianBanks.value.find(
    (i) => i.id == selectedBankID.value
  );
  console.log(selectedBank.value, "selectedBank");
  bankSearchText.value = selectedBank.value.name;
};

const selectGateway = (gateway) => {
  // prevent duplicates
  if (!selectedGateways.value.find((g) => g.id === gateway.id)) {
    selectedGateways.value.push(gateway);
    selectedGatewayName.value =
      gateway.displayName +
      " - " +
      gateway.config.bankName +
      " - " +
      gateway.config.bankAccountNumber;

    ElNotification({
      title: "Gateway Selected",
      message: `${gateway.displayName} was added successfully.`,
      type: "success",
      duration: 3000,
    });
  } else {
    ElNotification({
      title: "Already Added",
      message: `${gateway.displayName} is already in the list.`,
      type: "warning",
      duration: 3000,
    });
  }
};
const setSelectedGatewayPayment = () => {
  selectedPaymentGateway.value = gateWayPayments.value.find(
    (g) => g.id === selectGatewayPaymentID.value
  );
  console.log(selectedPaymentGateway.value, "Selected Gateway Payment");
};
const getFinancialGateway = async () => {
  loadingIntegrationType.value = true;
  if (!selectedPaymentForm.value?.value) return;

  try {
    const { data } = await axios.get(
      `api/Payment/GetPaymentGatewaysByIntegrationType`,
      {
        params: { integrationType: selectedPaymentForm.value?.id }, // pass id as query string
      }
    );
    gateWayPayments.value = data;
    selectGatewayPaymentID.value = null;
    loadingIntegrationType.value = false;
  } catch (err) {
    console.log("Error fetching payment gateways", err);
    loadingIntegrationType.value = false;
  }
};
// getFinancialGateway();
watch(selectedPaymentForm, (newVal) => {
  if (newVal) {
    getFinancialGateway();
  }
});
// Fetch church payment gateways
const fetchGateways = async () => {
  try {
    const res = await axios.get("/api/Payment/churchpaymentgateway");
    gateways.value = res.data || [];
  } catch (error) {
    console.error("Error fetching gateways:", error);
  }
};
fetchGateways();
// === Save handler ===
const saveGateway = async () => {
  let config = {};

  if (selectedPaymentForm.value?.value === "bank") {
    config = {
      // subAccountId: selectedBankID.value || "",
      bankName: selectedBank.value.name || "",
      bankCode: selectedBank.value.code || "",
      bankAccountNumber: accountNumber.value,
      accountName: accountName.value,
    };
  }

  if (selectedPaymentForm.value?.value === "connect") {
    config = {
      ...connectForm,
    };
  }

  if (selectedPaymentForm.value?.value === "pub-priv-key") {
    config = {
      ...keysForm,
    };
  }

  const payload = {
    // id: currentGatewayId.value,
    // tenantID: tenantId.value,
    paymentGatewayID: selectedPaymentGateway.value.id,
    displayName: selectedPaymentGateway.value.name,
    config,
    createdAt: new Date().toISOString(),
  };

  try {
    const res = await axios.post("/api/Payment/churchpaymentgateway", payload);
    if (res.data) {
      // Wait for gateways to refresh
      await fetchGateways();

      // Select the newest gateway (last one)
      if (gateways.value && gateways.value.length > 0) {
        const newest = gateways.value[gateways.value.length - 1];
        selectGateway(newest);
      }
    }
    ElNotification.success("Gateway saved successfully");
    showPaymentDialog.value = false;
  } catch (err) {
    ElNotification.error("Failed to save gateway");
    console.log(err);
  }
};
// confirm delete
const confirmDelete = (gateway) => {
  // ElMessageBox.confirm(
  //   `Are you sure you want to delete ${gateway.displayName} - ${gateway.bank} - ${gateway.accountNo}?`,
  //   "Confirm delete",
  //   {
  ElMessageBox.confirm(
    `Are you sure you want to delete ${gateway.displayName}?`,
    "Confirm delete",
    {
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      type: "error",
    }
  )
    .then(() => deleteGateway(gateway))
    .catch(() => {});
};

// delete from API
const deleteGateway = async (gateway) => {
  try {
    selectedGateways.value = selectedGateways.value.filter(
      (g) => g.id !== gateway.id
    );
    // await axios.delete(`/api/Payment/churchpaymentgateway/${gateway.id}`);
    // selectedGateways.value = selectedGateways.value.filter(
    //   (g) => g.id !== gateway.id
    // );
    ElNotification({
      title: "Success",
      message: "Gateway deleted successfully",
      type: "success",
    });
  } catch (err) {
    console.error(err);
    ElNotification({
      title: "Error",
      message: "Failed to delete gateway",
      type: "error",
    });
  }
};

const loadCurrencies = async () => {
  try {
    const response = await axios.get("/api/LookUp/GetAllCurrencies");
    currencyList.value = response.data;

    // Get the payment form currency
    // const userCurrencyObj = currencyList.value.find(
    //   (i) => i.id === currencyDetail.value.currency
    // );

    // Check if the payment currency is supported
    const userCurrencySupported = supportedCurrencies.find(
      (i) => i.value === currencyDetail.value?.currency
    );

    // Set default currency
    defaultCurrency.value = currencyDetail.value?.currency;
    // defaultCurrency.value = userCurrencyObj;
    // ? userCurrencyObj
    // : currencyList.value.find((i) => i.shortCode === "USD");

    givingForm.currency = userCurrencySupported
      ? userCurrencySupported.value
      : "USD";
  } catch (error) {
    console.error("Error loading currencies:", error);
  }
};
loadCurrencies();
const closeSubClassModal = () => {
  showSubClassModal.value = false;
};

const addNewSubclass = () => {
  if (
    selectedSubClassGroups.value.length === 0 ||
    selectedEvent.value.length === 0
  ) {
    ElNotification({
      title: "Error",
      message: "Please fill in all required fields.",
      type: "error",
    });
    return;
  }

  defaultCurrency.value = currencyList.value.find((i) => i.shortCode === "NGN");

  subclasses.value.push({
    eventDetails: subClassEventDetails.value,
    name: selectedEvent.value
      ? selectedEvent.value.name
      : selectedSUbClassEvent.value.fullEventName,
    isFree: markAsFree.value,
    registrationAmount: markAsFree.value ? 0 : givingForm.registrationAmount,
    currency: givingForm.currency,
    currencyID: defaultCurrency.value ? defaultCurrency.value.id : null,
    groupIDs: selectedSubClassGroups.value,
    activityId: selectedEvent.value.id,
  });
  ElNotification({
    title: "Success",
    message: "New subclass added successfully.",
    type: "success",
  });
  console.log(subclasses.value, "subclasses");

  resetSubclassForm();
  showSubClassModal.value = false;
};
const saveNewAddOn = () => {
  if (!addOnName.value) return;

  addOns.value.push({
    name: addOnName.value,
    isFree: markAddOnAsFree.value,
    amount: markAddOnAsFree.value ? 0 : givingForm.amount,
    // currency: givingForm.currency,
  });
  ElNotification({
    title: "Success",
    message: "New Add-on added successfully.",
    type: "success",
  });

  resetAddOnForm();
  showAddOnModal.value = false;
};
// Reset
const resetSubclassForm = () => {
  // selectedSUbClassEvent.value = {};
  subClassEventDetails.value = "";
  selectedSubClassGroups.value = [];
  givingForm.registrationAmount = null;
  // givingForm.currency = null;
};

const resetAddOnForm = () => {
  addOnName.value = "";
  givingForm.amount = null;
  // givingForm.currency = null;
};
// Remove item
const removeSubclass = (id, index) => {
  subclasses.value.splice(index, 1);
  ElNotification({
    type: "success",
    message: "Delete successful",
    duration: 5000,
  });
};

const removeAddOn = (id, index) => {
  addOns.value.splice(index, 1);
  ElNotification({
    type: "success",
    message: "Delete successful",
    duration: 5000,
  });
};
const showConfirmModal = (id, index) => {
  ElMessageBox.confirm("Are you sure you want to proceed?", "Confirm delete", {
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    type: "error",
  })
    .then(() => {
      removeAddOn(id, index);
    })
    .catch(() => {
      ElNotification({
        type: "info",
        message: "Delete canceled",
        duration: 5000,
      });
    });
};
const showConfirmDialog = (id, index) => {
  ElMessageBox.confirm("Are you sure you want to proceed?", "Confirm delete", {
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
    type: "error",
  })
    .then(() => {
      removeSubclass(id, index);
    })
    .catch(() => {
      ElNotification({
        type: "info",
        message: "Delete canceled",
        duration: 5000,
      });
    });
};
// const selectedGroup = ref({});

const attendanceCheID = ref(route.params.id);
const eventNameDate = ref("");

const setIncomeAccount = (item) => {
  selectedIncomeAccount.value = item;
};
const setGroupValue = () => {
  flattenedTree.value.find((i) => i.value == selectedGroups.value);
};
const setcashBankAccount = (item) => {
  selectedCashAccount.value = item;
};

const openPaymentModal = () => {
  showPaymentDetail.value = true;
};
const Contiue = () => {
  showPaymentDetail.value = false;
};
const cancel = () => {
  showPaymentDetail.value = false;
};
const triggerNewEvent = () => {
  showEventModal.value = true;
};
const createNewCat = () => {
  showEventCatModal.value = true;
};

const getSingleCheckinAttendance = async () => {
  try {
    const res = await axios.get(
      `/api/CheckInAttendance/GetSingleAttendanceCheckIn?checkInAttendanceId=${attendanceCheID.value}`
    );

    eventNameDate.value = `${
      res.data.returnObject.attendanceItem.fullEventName
    } (${new Date(
      res.data.returnObject.attendanceItem.eventDate
    ).toDateString()})`;
    selectedEvent.value.name = `${
      res.data.returnObject.attendanceItem.fullEventName
    } (${new Date(
      res.data.returnObject.attendanceItem.eventDate
    ).toDateString()})`;
  } catch (error) {
    console.log(error);
  }
};
if (attendanceCheID.value) getSingleCheckinAttendance();

const groupMappedTree = ref([]);
const flattenedTree = ref([]);
const getGroups = async () => {
  grouploading.value = true;
  try {
    const response = await groupService.getGroups();
    grouploading.value = false;
    if (response.response && response.response.groupResonseDTO.length > 0) {
      groups.value = response.response.groupResonseDTO;
    }
    let data = { children: groups.value };
    const { children } = collector(data);
    groupMappedTree.value = children;
    if (groupMappedTree.value && groupMappedTree.value.length > 0) {
      flattenedTree.value = groupMappedTree.value.flatMap(flatten());
    }
  } catch (error) {
    console.log(error);
    grouploading.value = false;
  }
};
const getAttendancePage = async () => {
  try {
    const { data } = await axios.get(
      `api/CheckInAttendance/AllCheckInAttendances?page=1`
    );
    checkinAttendnceData.value = data.data;
  } catch (error) {
    console.log(error);
  }
};
getAttendancePage();

const events = ref([]);
const getEvents = async () => {
  try {
    const response = await eventsService.getEvents();
    if (response && response.length > 0) {
      events.value = response.map((i) => {
        return { id: i.activityID, name: i.name, date: i.date };
      });
    }
  } catch (error) {
    console.log(error);
  }
};
const filterNodeMethod = (value, data) =>
  data.label.toLowerCase().includes(value.toLowerCase());
const selectedEvent = ref({});
const selectedSUbClassEvent = ref({});
const selectedAddOn = ref({});
const createNewSubclass = () => {
  showSubClassModal.value = true;
};
const addNewAddOn = () => {
  showAddOnModal.value = true;
};
const selectEvent = (selected) => {
  selectedEvent.value = selected;
  // eventSearchText.value = ''
};
const selectSubClassEvent = (selected) => {
  selectedSUbClassEvent.value = selected;
  console.log(selectedSUbClassEvent.value, "dhhh");
  subclasses.value.push({
    id: selectedSUbClassEvent.value.id,
    eventDetails: subClassEventDetails.value,
    name: selectedSUbClassEvent.value.fullEventName,
    isFree: markAsFree.value,
    registrationAmount: markAsFree.value ? 0 : givingForm.registrationAmount,
    // currency: givingForm.currency,
    currencyID: defaultCurrency.value ? defaultCurrency.value.id : null,
    groupIDs: selectedSubClassGroups.value,
    activityId: selectedSUbClassEvent.value.eventID,
  });
  console.log(subclasses.value, "subclasses");
  // eventSearchText.value = ''
};
const selectAddOn = (selected) => {
  selectedAddOn.value = selected;
  console.log(selected, "kkkk");

  addOns.value.push({
    id: selectedAddOn.value.id ? selectedAddOn.value.id : "",
    name: selectedAddOn.value.name,
    isFree: selectedAddOn.value.isFree,
    amount: selectedAddOn.value.isFree ? 0 : givingForm.amount,
    // currency: selectedAddOn.value.currency,
  });
  // eventSearchText.value = ''
  console.log(addOns.value, "addOns");
};

const closeModal = () => {
  // display.value = false;
  showEventCatModal.value = false;
};

const eventCategories = ref([]);
const getEventCategories = async () => {
  try {
    const response = await eventsService.getEventCategories();
    eventCategories.value = response;
  } catch (error) {
    console.log(error);
  }
};
getEventCategories();

const selectedCategory = ref({});
const selectCategory = (category) => {
  selectedCategory.value = category;
  newActModal.value = false;
};

const newAcctivityDate = ref("");
const getCorrectDate = (date) => {
  return new Date(date).toLocaleDateString("en-US").replaceAll("/", "-");
};
const createNewActivity = async () => {
  if (!newAcctivityDate.value && !selectedCategory.value) return false;
  try {
    const response = await eventsService.createNewActivity({
      activity: {
        date: getCorrectDate(newAcctivityDate.value),
        eventCategoryId: selectedCategory.value.id,
      },
    });
    const newActivity = {
      id: response.currentEvent.id,
      name: `${response.currentEvent.name} (${new Date(
        response.currentEvent.activityDate
      ).toDateString()})`,
      date: getCorrectDate(newAcctivityDate.value),
    };
    selectedEvent.value = newActivity;
    events.value.push(newActivity);
    ElNotification({
      message: "Event created successfully",
      type: "success",
      duration: 2000,
    });

    showEventModal.value = false;
  } catch (error) {
    ElNotification({
      type: "error",
      message: "Could not create event",
      duration: 2000,
    });
    console.log(error);
  }
};

const selectedCategoryName = computed(() => {
  if (!selectedCategory.value || !selectedCategory.value.name) return "";
  return selectedCategory.value.name.length > 17
    ? `${selectedCategory.value.name.slice(0, 16)}...`
    : selectedCategory.value.name;
});

const newCategoryCreated = (categories, eventName) => {
  eventCategories.value = categories;
  selectedCategory.value = categories.find(
    (i) => i.name.toLowerCase() === eventName.toLowerCase()
  );
  // openModalBtn.value.click();
  // display.value = false;
  showEventCatModal.value = false;
};

const categorySearchText = ref("");
const filteredCategories = computed(() => {
  if (!categorySearchText.value) return eventCategories.value;
  return eventCategories.value.filter((i) =>
    i.name.toLowerCase().includes(categorySearchText.value.toLowerCase())
  );
});

const bankSearchText = ref("");
const filteredBanks = computed(() => {
  if (!bankSearchText.value) return nigerianBanks.value;
  return nigerianBanks.value.filter((i) =>
    i.name.toLowerCase().includes(bankSearchText.value.toLowerCase())
  );
});

const eventSearchText = ref("");
const filteredEvents = computed(() => {
  if (!selectedEvent.value.name) return events.value;
  return events.value.filter((i) =>
    i.name.toLowerCase().includes(selectedEvent.value.name.toLowerCase())
  );
});
const filterCheckinAttendnceData = computed(() => {
  if (!selectedSUbClassEvent.value.fullEventName)
    return checkinAttendnceData.value;
  return checkinAttendnceData.value.filter((i) =>
    i.fullEventName
      .toLowerCase()
      .includes(selectedSUbClassEvent.value.fullEventName.toLowerCase())
  );
});
const filterAddOn = computed(() => {
  if (!selectedAddOn.value.name) return addOns.value;
  return addOns.value.filter((i) =>
    i.name.toLowerCase().includes(selectedAddOn.value.name.toLowerCase())
  );
});

getEvents();
getGroups();

const searchLocations = async (query) => {
  if (!query.trim()) {
    searchResults.value = [];
    return;
  }

  isSearching.value = true; // Should trigger the spinner

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        query
      )}&addressdetails=1`
    );
    if (!response.ok) throw new Error("Failed to fetch");
    const data = await response.json();
    searchResults.value = data;
  } catch (error) {
    searchResults.value = [];
    ElNotification({
      type: "error",
      message: "Failed to fetch locations",
      duration: 3000,
    });
    console.error(error);
  } finally {
    isSearching.value = false; // Hides spinner after API call completes
  }
};
const handleSearchInput = () => {
  clearTimeout(debounceTimer.value);
  debounceTimer.value = setTimeout(() => {
    searchLocations(searchQuery.value).then(() => {
      dropdownVisible.value = searchResults.value.length > 0;
    });
  }, 500);
};
const handleInputFocus = () => {
  if (searchQuery.value && searchResults.value.length > 0) {
    dropdownVisible.value = true;
  }
};
const handleDropdownToggle = (visible) => {
  if (visible && searchQuery.value && searchResults.value.length === 0) {
    // Re-search when dropdown is manually opened
    searchLocations(searchQuery.value);
  }
};

const selectLocation = (location) => {
  selectedLocation.value = {
    display_name: location.display_name,
    address: {
      road: location.address?.road || "",
      city: location.address?.city || location.address?.town || "",
      state: location.address?.state || "",
      country: location.address?.country || "",
      postal_code: location.address?.postcode || "",
    },
    coordinates: {
      lat: parseFloat(location.lat),
      lon: parseFloat(location.lon),
    },
  };

  searchQuery.value = location.display_name;
  dropdownVisible.value = false; // ✅ close the dropdown
  console.log("Selected location:", selectedLocation.value);
  // You can emit this to parent component or save to backend
};

const onContinue = async () => {
  loadingsave.value = true;

  const formData = new FormData();

  if (subclasses?.value?.length) {
    const cleanSubs = subclasses.value.filter(Boolean).map((e) => ({
      ...e,
      registrationAmount: Number(e.registrationAmount) || 0,
      groupIDs: Array.isArray(e.groupIDs) ? e.groupIDs : [],
    }));

    if (cleanSubs.length > 0) {
      formData.append("subEvents", JSON.stringify(cleanSubs));
    }
  }

  if (addOns?.value?.length) {
    const cleanAddOns = addOns.value.filter(Boolean).map((a) => ({
      ...a,
      amount: Number(a.amount) || 0,
    }));

    if (cleanAddOns.length > 0) {
      formData.append("eventAddOns", JSON.stringify(cleanAddOns));
    }
  }

  image.value ? formData.append("bannerPhoto", image.value) : "";
  formData.append("details", eventDetails.value);
  formData.append(
    "tenantPaymentGatewayOptions",
    JSON.stringify(
      selectedGateways.value.map((gw, idx) => ({
        churchPaymentGatewayID: gw.id,
        entityUsingPaymentGateWay: 3,
        priority: idx,
        isEnabled: 1,
      }))
    )
  );

  formData.append("address", searchQuery.value ? searchQuery.value : "");
  formData.append(
    "lat",
    selectedLocation.value ? selectedLocation.value.coordinates.lat : ""
  );
  formData.append(
    "lon",
    selectedLocation.value ? selectedLocation.value.coordinates.lon : ""
  );
  selectedBank.value
    ? formData.append(
        "bankCode",
        selectedBank.value ? selectedBank.value.code : ""
      )
    : "";
  accountName.value ? formData.append("accountName", accountName.value) : "";
  accountNumber.value
    ? formData.append("accountNumber", accountNumber.value)
    : "";
  formData.append("contributionItemName", selectedEvent.value.name);
  selectedCashAccount.value
    ? formData.append(
        "cashAccountId",
        selectedCashAccount.value ? selectedCashAccount.value.id : ""
      )
    : "";
  selectedIncomeAccount.value && selectedIncomeAccount.value.id
    ? formData.append(
        "incomeAccountId",
        selectedIncomeAccount.value && selectedIncomeAccount.value.id
          ? selectedIncomeAccount.value.id
          : ""
      )
    : "";
  registrationSMS.value
    ? formData.append("registrationSMS", registrationSMS.value)
    : "";
  registrationSMSSubject.value
    ? formData.append("registrationSMSSubject", registrationSMSSubject.value)
    : "";
  registrationEmail.value
    ? formData.append("registrationEmail", registrationEmail.value)
    : "";
  registrationEmailSubject.value
    ? formData.append(
        "registrationEmailSubject",
        registrationEmailSubject.value
      )
    : "";
  checkinSMS.value ? formData.append("checkinSMS", checkinSMS.value) : "";
  checkinSMSSubject.value
    ? formData.append("checkInSMSSubject", checkinSMSSubject.value)
    : "";
  checkinEmail.value ? formData.append("checkinEmail", checkinEmail.value) : "";
  checkinEmailSubject.value
    ? formData.append("checkinEmailSubject", checkinEmailSubject.value)
    : "";
  selectedEvent.value
    ? formData.append("activityDate", getCorrectDate(selectedEvent.value.date))
    : "";
  // formData.append("isPaidFor", addPaidClass.value);
  formData.append("isPaidFor", markAsPaid.value);
  amount.value ? formData.append("registrationAmount", amount.value) : "";
  selectedEvent.value
    ? formData.append("activityId", selectedEvent.value.id)
    : "";

  formData.append("enableRegistration", true);
  slot.value ? formData.append("registrationSlot", slot.value) : "";
  regCutOffTimer.value
    ? formData.append("registrationCutOffTime", regCutOffTimer.value)
    : "";
  checkinCutOffTime.value
    ? formData.append("checkInCutOffTime", checkinCutOffTime.value)
    : "";
  selectedGroups.value
    ? formData.append("groupIDs", JSON.stringify(selectedGroups.value))
    : "";

  if (attendanceCheID.value) {
    attendanceCheID.value ? formData.append("Id", attendanceCheID.value) : "";
    loadingsave.value = true;
    try {
      const res = await axios.put(
        "/api/CheckInAttendance/EditAttendanceCheckIn",
        formData
      );
      console.log(res);
      store.dispatch("attendance/setItemData", res);
      ElNotification({
        type: "success",
        message: res.data.response,
        duration: 5000,
      });
      store.dispatch("attendance/setAttendanceItemData");
      router.push({
        name: "CheckinType",
        query: {
          activityID: selectedEvent.value.id,
          activityName: selectedEvent.value.name,
          groupId: selectedGroups.value[0].id,
          groupName: selectedGroups.value[0].name,
          id: res.data.id,
          code: res.data.attendanceCode,
        },
      });
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      const response = await axios.post(
        "api/CheckInAttendance/CreateAttendanceCheckIn",
        formData
      );
      for (
        let i = 0;
        i < response.data.returnObject.checkInAttendanceResult.length;
        i++
      ) {
        const element = response.data.returnObject.checkInAttendanceResult[i];
        store.dispatch("attendance/setItemData", element);
      }
      store.dispatch("attendance/setAttendanceItemData");
      store.dispatch("groups/setCheckedTreeGroup", []);
      loadingsave.value = false;
      router.push({
        name: "CheckinType",
        query: {
          activityID: selectedEvent.value.id,
          activityName: selectedEvent.value.name,
          groupId: selectedGroups.value[0].id,
          groupName: selectedGroups.value[0].name,
          id: response.data.returnObject.checkInAttendanceResult[0].id,
          code: response.data.returnObject.checkInAttendanceResult[0]
            .attendanceCode,
        },
      });
    } catch (error) {
      console.log(error);
      loadingsave.value = false;
    }
  }
};

const showPaidTab = () => {
  addPaidClass.value = true;
  addFreeClass.value = false;
};

const showFreeTab = () => {
  addFreeClass.value = true;
  addPaidClass.value = false;
};

const toggleTemplate = () => {
  templateDisplay.value = !templateDisplay.value;
};

const getBanks = () => {
  axios
    .get("/api/Financials/GetBanks")
    .then((res) => {
      nigerianBanks.value = res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
getBanks();

const resolveCustomerDetail = async () => {
  loading.value = true;
  try {
    let header = {
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_PAYSTACK_SECRET_KEY}`,
      },
    };

    let { data } = await axio.get(
      `https://api.paystack.co/bank/resolve?account_number=${accountNumber.value}&bank_code=${selectedBank.value.code}`,
      header
    );
    accountName.value = data.data.account_name;
    // accNameRef.value.focus();
    // disabled.value = false

    loading.value = false;

    ElNotification({
      type: "success",
      message: "Account Check Successful",
      duration: 5000,
    });
  } catch (error) {
    finish();
    console.log(error);

    loading.value = false;

    ElNotification({
      type: "error",
      message: "Account Check Error, Please check your banks details again ",
      duration: 5000,
    });
  }
};

const getCashBankAccount = () => {
  axios
    .get("/api/financials/accounts/getcashbankaccounts")
    .then((res) => {
      cashBankAccount.value = res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
getCashBankAccount();

const getIncomeAccount = () => {
  axios
    .get("/api/Financials/Accounts/GetIncomeAccounts")
    .then((res) => {
      incomeAccount.value = res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
getIncomeAccount();

const altClick = () => {
  binImage.value.click();
};

const chooseFile = (e) => {
  image.value = e.target.files[0];
  imageUrl.value = URL.createObjectURL(image.value);
};

const setBank = (item) => {
  selectedBank.value = item;
};

const setGroupProp = () => {
  hideDiv.value = !hideDiv.value;
  nextTick(() => {
    searchGroupRef.value.focus();
  });
};

const searchForGroups = computed(() => {
  if (!searchGroupText.value.name && groups.value.length > 0)
    return groups.value;
  return groups.value.filter((i) =>
    i.name.toLowerCase().includes(searchGroupText.value.toLowerCase())
  );
});

const closeDropdownIfOpen = (e) => {
  if (
    !e.target.classList.contains("exempt-hide") &&
    !e.target.classList.contains("p-hidden-accessible") &&
    !e.target.classList.contains("p-checkbox-box") &&
    !e.target.classList.contains("p-checkbox-icon")
  ) {
    // hideDiv.value = true;
  }
};

const setFilterGroups = (payload) => {
  selectedGroups.value = payload;
};
const setFilterSubClassGroups = (payload) => {
  selectedSubClassGroups.value = payload;
};

const setNewGroup = (payload) => {
  groups.value.push(payload);
};

const setSelectedSenderIdCheckin = (payload) => {
  checkinSMSSubject.value = payload;
};

const setSelectedSenderIdRegistration = (payload) => {
  registrationSMSSubject.value = payload;
};
</script>

<style scoped>
.error-border {
  border: 1px solid red !important;
  border-radius: 8px;
}
/* Tab Button Styling */
.custom-tabs {
  display: flex;
  align-items: center;
}
.activeSubTab {
  border: none;
  background: none;
  font-weight: 500;
  font-size: 16px;
  margin-right: 20px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 0%;
  border-bottom: 2px solid #0745af66;
  transition: all 0.3s ease;
  color: #000;
  outline: none !important;
}
.activeSubTab.active {
  /* border: none; */
  color: #000000; /* White text */
  border-bottom: 2px solid #0046c0 !important;
  border-radius: 0%;
  outline: none !important;
}
.activeSubTab:hover {
  border-radius: 0% !important;
  border-bottom: 4px solid #0046c0 !important;
  color: #000000;
  outline: none !important;
}
.custom-tab.active {
  /* border: none; */
  background: #0745af0d;
  color: #000000; /* White text */
  border-bottom: 4px solid #0046c0 !important;
  border-radius: 0%;
  outline: none !important;
}
.custom-tab:hover {
  border-radius: 0% !important;
  border-bottom: 4px solid #0046c0 !important;
  background: #0745af0d;
  color: #000000;
  outline: none !important;
}
.menu-height {
  max-height: 250px;
  overflow-y: auto;
}
.custom-tab {
  border: none;
  background: none;
  font-weight: 500;
  font-size: 16px;
  margin-right: 20px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  color: #000;
  outline: none !important;
}

/* Section spacing */
.tab-section {
  margin-top: 30px;
}

/* Save & Continue button */
.btn-save {
  background-color: #0046c0;
  color: #fff;
  border-radius: 25px;
  font-weight: 500;
  padding: 10px 40px;
}
.btn-save:hover {
  background-color: #003399;
  color: #fff;
}
* {
  color: #02172e;
}
.amount-input-group {
  display: flex;
  gap: 0;
}
.currency-select {
  width: 100px;
  flex-shrink: 0;
}
.amount-input {
  flex: 1;
}
:deep(.currency-select .el-input__wrapper) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: none;
}

:deep(.amount-input .el-input__wrapper) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.default-bt {
  font-weight: 600 !important;
  white-space: initial;
  border-radius: 3rem;
  border: 0.6px solid #0040ff !important;
  /* padding: 0.5rem 1.25rem; */
  /* width: auto; */
  outline: transparent !important;
  height: 40px !important;
  background: #fff;
  /* min-width: 121px; */
  /* width: 105px !important; */
  display: flex !important;
  align-items: center !important;
  /* justify-content: center !important; */
}

.upload-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  background-color: #ebedff;
}
.upload-area-btn {
  border: 2px dashed #0745af !important;
  color: #0745af !important;
}

.upload-box {
  color: #007bff;
  font-weight: bold;
}

.border-contribution {
  border: 1.6px solid rgb(229, 232, 237);
  border-radius: 4px;
  padding: 11px 7px;
}

.contn-btn:disabled {
  opacity: 0.3;
}

.menu-height {
  max-height: 400px;
  overflow: scroll;
}

.upload-button {
  background: rgba(206, 206, 206, 0.274);
  color: black;
  /* border-radius: 25px; */
  font-weight: 600;
  padding: 8px 10px;
}

.active-tab {
  border-bottom: 2px solid rgb(31, 87, 241);
}

.header-contri {
  font-size: 20px;
  font-weight: 700;
}
/* .img-border {
      border: 1px dotted rgb(206, 212, 218); 
      height: 150px;
    } */

.show-paid {
  height: 327px;
  /* overflow: hidden; */
  transition: all 0.6s ease-in-out;
}

.hide-paid {
  height: 0;
  overflow: hidden;
  transition: all 0.6s ease-in-out;
}

.input-width {
  width: 100%;
}

.input-width {
  width: 100%;
}

@media (min-width: 992px) {
  .input-width {
    width: 350px;
  }
}

@media (max-width: 576px) {
  .show-tem-free {
    height: 1241px;
  }

  .show-tem {
    height: 1774px;
    /* overflow: hidden; */
    transition: all 1s ease-in-out;
  }

  .show-paid {
    height: 560px;
    /* overflow: hidden; */
    transition: all 0.6s ease-in-out;
  }
}

.show-amount {
  /* width: 100%;
      overflow: hidden; */
  transform: translateX(0px);
  opacity: 1;
  transition: all 0.6s ease-in-out;
}

.hide-amount {
  opacity: 0;
  transition: all 0.6s ease-in-out;
}

#second {
  width: 100%;
}

.div-card {
  position: absolute;
  background: white;
  z-index: 1;
  width: 100%;
  top: 40px;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  max-height: 400px;
  overflow: scroll;
}

.eachGroup {
  padding: 5px 10px;
  background: #eee;
  border-radius: 25px;
  margin: 0 3px;
}

.angle-icon {
  border: 1px solid #dde2e6;
  padding: 2px;
  border-radius: 50%;
  height: 30px;
  width: 30px;
  color: #91949c;
}
</style>
